import React from 'react';
import PropTypes from 'prop-types';

export default function ProjectThumbnail({ imageContainerStyle, imageStyle, noShadow, thumbnailUrl }) {
  const containerStyle = imageContainerStyle || imageStyle || {};

  return (
    <div
      className="layout-header position-relative m-auto d-inline-block mr-4"
      style={{ ...containerStyle, margin: 'auto' }}
    >
      <img
        alt="Thumb"
        className={`${noShadow ? '' : 'shadowed '}d-block project-thumbnail`}
        src={thumbnailUrl}
        style={imageStyle}
      />
    </div>
  );
}

ProjectThumbnail.propTypes = {
  imageContainerStyle: PropTypes.object,
  imageStyle: PropTypes.object,
  noShadow: PropTypes.bool,
  thumbnailUrl: PropTypes.string
};
